"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { SITE } from "@/lib/site";

// Lightweight first-party funnel: page_view + tagged click events into the
// shared signups DB via /api/event (source-partitioned). Best-effort, never blocks.
function sessionId() {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem("pa_sid");
  if (!id) {
    id = (crypto.randomUUID?.() || String(Date.now()) + Math.random().toString(16).slice(2));
    sessionStorage.setItem("pa_sid", id);
  }
  return id;
}

function utm() {
  const p = new URLSearchParams(window.location.search);
  const o: Record<string, string> = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_adgroup", "gclid", "msclkid"].forEach((k) => {
    const v = p.get(k);
    if (v) o[k] = v;
  });
  return o;
}

function emit(eventType: string, page: string, data?: string) {
  try {
    fetch("/api/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        source: SITE.source,
        session_id: sessionId(),
        event_type: eventType,
        page,
        data,
        landing_url: window.location.href,
        ...utm(),
      }),
      keepalive: true,
    });
  } catch {
    /* ignore */
  }
}

export function FunnelTracking() {
  const pathname = usePathname();

  useEffect(() => {
    emit("page_view", pathname || "/");

    const onClick = (e: MouseEvent) => {
      const el = (e.target as HTMLElement)?.closest?.("[data-track]") as HTMLElement | null;
      if (el) emit("click", pathname || "/", el.getAttribute("data-track") || "");
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [pathname]);

  return null;
}
